<template>
    <div>
      <input
      @keypress="lettersOnly"
      :type="type"
      :name="name"
      :min="min"
      :class="{'error': error, 'success': success, 'disabled': disabled}"
      :disabled="disabled"
      :value="value"
      @keyup.enter="$emit('enter')"
      @input="$emit('input', $event.target.value)"
      class="form-control"
      :placeholder="placeholder">
      <p id="errorMessageJS" class="error-message">{{errorMessage}}</p>
    </div>
</template>

<script>
export default {
  props: {
    placeholder: String,
    type: String,
    value: {
      type: [String, Number],
      required: false
    },
    disabled: {
      type: Boolean,
      required: false
    },
    error: {
      type: Boolean,
      required: false
    },
    success: {
      type: Boolean,
      required: false
    },
    name: {
      type: String,
      required: false
    },
    min: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      errorMessage: ''
    }
  },
  methods: {
    // Only allow certain characters to be typed in, prevent everything else
    lettersOnly (e) {
      if ((e.keyCode >= 97 && e.keyCode <= 122) || // [a-z]
          (e.keyCode >= 65 && e.keyCode <= 90) ||  // [A-Z]
          (e.keyCode >= 48 && e.keyCode <= 57) ||  // [0-9]
           e.keyCode === 8 || e.keyCode === 13 || e.keyCode === 32) /* [Backspace] [Enter] [Spacebar] */ {
        // Class and ID changes are for animation purposes
        let errorMessageJS = document.getElementById('errorMessageJS')
        errorMessageJS.classList.remove('error-message')
        this.errorMessage = ''
      } else {
        e.preventDefault()
        console.log(e.keyCode)
        let errorMessageJS = document.getElementById('errorMessageJS')
        errorMessageJS.classList.add('error-message')
        this.errorMessage = 'Only characters [a-z], [A-Z], [0-9] allowed!'
      }
    }
  }
}
</script>

<style scoped>
.error {
  border-color: red !important;
}
.success {
  border-color: #58d858 !important;
}
.disabled {
  border-color: rgb(155, 155, 155);
  background-color: rgb(214, 214, 214);
}

.error-message {
  animation-name: opacityAppear;
  animation-duration: 0.25s;
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
  color: red;
}

@keyframes opacityAppear {
  0% {
    opacity: 0;
  }

  100% {
    opacity:  1;
  }
}
</style>
